import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import { DOCS_CHAT_REQUEST_TIMEOUT_MS } from '@/api/docs/docs.constants';
import {
  IDocsApi,
  IDocsChatRequest,
  IDocsChatResponse,
  IGetDocsAssetTokenResponse,
  IGetDocsPageResponse,
  IGetDocsTreeResponse,
  IGetDocsVideoResponse,
} from '@/api/docs/docs.types';

export class DocsApi implements IDocsApi {
  private getBaseUrl(): string {
    return ApiEndpoints.DOCS;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getTree() {
    return this.httpClient.get<IGetDocsTreeResponse>(`${this.getBaseUrl()}tree`);
  }

  getPageContent(path: string) {
    return this.httpClient.get<IGetDocsPageResponse>(`${this.getBaseUrl()}content/${path}`);
  }

  getAssetToken() {
    return this.httpClient.post<Record<string, never>, IGetDocsAssetTokenResponse>(
      `${this.getBaseUrl()}asset-token`,
      {},
    );
  }

  getVideoUrl(path: string) {
    return this.httpClient.get<IGetDocsVideoResponse>(`${this.getBaseUrl()}video/${path}`);
  }

  postChat(request: IDocsChatRequest) {
    return this.httpClient.post<IDocsChatRequest, IDocsChatResponse>(
      `${this.getBaseUrl()}chat`,
      request,
      { timeout: DOCS_CHAT_REQUEST_TIMEOUT_MS },
    );
  }
}
